
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import { getList } from '../utils/api'



const imgList = [
{url: 'javascript:',img:'http://yawen.xjinshop.com/images/img/index1.jpg'},
{url: 'javascript:',img:'http://yawen.xjinshop.com/images/img/index2.jpg'},
{url: 'javascript:',img:'http://yawen.xjinshop.com/images/img/index3.jpg'}
]


const navList = [
{name:'物业缴费',url: '/PaymentCenter',img:'icon_wy.png'},

{name:'在线报修',url: '/Fix',img:'icon_phone.png'},
{name:'投诉处理',url: '/Complain',img:'icon_fk.png'},
{name:'常见问题',url: '/HelpCenter',img:'icon_sq.png'},
{name:'申请放行',url: '/LetPass',img:'icon_et.png'},


]



/*const urlList = imgList.map((one, index) => ({
url: 'javascript:',  //这里填写图片点击的链接
img: one
}))*/

export default{
name: 'NewsList',
data(){
return{
ishow:false,
pageIndex:1,
catalog:0,
imgs:imgList,
navs:navList
}
},
components:{
Scroller,
Cell,
Group,
Divider,
Swiper
},
created () {
this.getList()

},
methods:{
getList:function() {
this.ishow=true;
this.locked = false
this.loading = false
},
load:function (uuid) {
setTimeout(() => {
this.getList();
this.$broadcast('pulldown:reset', uuid)
}, 1000)
},
}
}



// WEBPACK FOOTER //
// ./src/components/NewsList.vue